import {
  Component,
  OnInit,
  Input,
  Inject,
  forwardRef,
  ViewChild
} from '@angular/core';
import { ActivityEditorBaseComponent } from '../activity-editor-base/activity-editor-base.component';
import { CompleteActivityReasons, CompleteWorkflowActivity } from '../../../../models/activities';
import { SecurityService } from '../../../../services';
import { ModalConfirmComponent } from './../../../system/modal-confirm/modal-confirm.component';
import { Actions } from 'src/app/models';

@Component({
    selector: 'wm-complete-workflow-activity-editor',
    templateUrl: './complete-workflow-activity-editor.component.html',
    styleUrls: ['./complete-workflow-activity-editor.component.css'],
    standalone: false
})
export class CompleteWorkflowActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {
  @Input() activity: CompleteWorkflowActivity;
  activityId: string;

  availableReasons: string[] = [];
  incompleteReason = CompleteActivityReasons.INCOMPLETE;

  @ViewChild('autoSubmitModal', { static: true }) autoSubmitModal: ModalConfirmComponent;

  constructor(
    @Inject(forwardRef(() => SecurityService)) private _securitySvc: SecurityService
  ) {
    super();
  }

  ngOnInit() {
    // the Incomplete reason is behind permission, but if it's 
    // already configured as Incomplete, show it no matter what.
    if (this.activity.model.reason === this.incompleteReason) {
      this.availableReasons = CompleteActivityReasons.ALL_REASONS;
    } else {
      this._securitySvc.isLoginEntitled(Actions.CONFIGURE_INCOMPLETE_END_ACTIVITY)
      .subscribe(isEntitled => {
        if (isEntitled) {
          this.availableReasons = CompleteActivityReasons.ALL_REASONS;
        } else {
          this.availableReasons = CompleteActivityReasons.ALL_REASONS.filter(r => r !== this.incompleteReason);
        }
      })
    }
  }

  autoSubmitWarn() {
    if (this.activity.model.autoSubmit === true) {
      setTimeout(() => {
        this.autoSubmitModal.open();
      }, 10);
    }
  }

  cancelAutoSubmit() {
    this.activity.model.autoSubmit = false;
  }
}
